/* eslint-disable indent */
/* eslint-disable no-console */
/* eslint-disable func-names */
import React, { useState, useEffect } from 'react';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import parse from 'html-react-parser';
import { Buffer } from 'buffer';
import Axios from 'axios';
import { get, isEmpty } from 'lodash';

import Loader from '../../components/Loader';

import config from '../../config';

import useSolicitudData from './hooks/useSolicitudData';
import SummaryStep from './steps/SummaryStep';
import SelfieStep from './steps/SelfieStep';
import NumberInputStep, {
  TIPO_CAMBIO,
  validateNumero,
} from './steps/NumberInputStep';

import {
  Content,
  NavBarContainer,
  ContainerGeneral,
  ContainerDialogTerms,
} from './styledComponents';

window.Buffer = window.Buffer || Buffer;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const options = {
  // eslint-disable-next-line consistent-return
  replace: domNode => {
    if (domNode.attribs && domNode.attribs.class === 'remove') {
      return <></>;
    }
  },
};

const ConfirmarSolicitudCambio = props => {
  const token = get(props, 'match.params.token', '');

  const {
    loading,
    notFound,
    alreadyUsed,
    distribuidora,
    tipoCambio,
    tokenNubarium,
    termsAndConditions,
    identityValidationAttempts,
    nombreCompletoDistribuidora,
    bancos,
    segurosDistribuidoras,
  } = useSolicitudData(token);

  const [termsAgreed, setTermsAgreed] = useState(false);
  const [termsAgreedOpen, setTermsAgreedOpen] = useState(false);

  const [started, setStarted] = useState(false);
  const [loadingFull, setLoadingFull] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [successText, setSuccessText] = useState('');

  const [showIdentityValidator, setShowIndentityValidator] = useState(true);
  const [solicitudConfirmed, setSolicitudConfirmed] = useState(false);

  const [validationAttempt, setValidationAttempt] = useState('');
  const [errorSelfie, setErrorSelfie] = useState('');

  const [selfie, setSelfie] = useState(null);
  const [alreadyFaceCapture, setAlreadyFaceCapture] = useState(false);
  const [errorFaceCapture, setErrorFaceCapture] = useState(false);
  const [currentlyFaceCapture, setCurrentlyFaceCapture] = useState(false);
  const [successSelfie, setSuccessSelfie] = useState('');

  const [numero, setNumero] = useState('');
  const [numeroTouched, setNumeroTouched] = useState(false);
  const [bancoId, setBancoId] = useState(0);
  const [seguroId, setSeguroId] = useState(0);

  const [activeStep, setActiveStep] = useState(0);

  const disabled =
    !termsAgreed || (showIdentityValidator && !selfie) || errorSelfie;

  const FaceComponent = () => {
    // eslint-disable-next-line no-undef
    const faceCapture = new FaceCapture();

    const faceCaptureConfig = {
      rootElement: 'face_component',
      maxValidations: 3,
      features: {
        disabled: ['glasses', 'facemask'],
        enabled: [],
      },
      antispoofing: {
        enabled: true,
        level: 3,
      },
    };

    faceCapture.setToken(tokenNubarium);

    faceCapture.init(faceCaptureConfig);

    faceCapture.load(() => {
      faceCapture.start();
    });

    faceCapture.onEvaluation((evaluation, result) => {
      const ev = evaluation;
    });

    faceCapture
      .onSuccess(data => {
        console.log('onSuccess', data);
        setAlreadyFaceCapture(true);
        setCurrentlyFaceCapture(false);
        setSelfie(data.frame);
      })
      .onFail(fail => {
        console.log('onFail', fail);
        setTimeout(() => {
          faceCapture.retry();
        }, 100);
      })
      .onError(error => {
        console.log('onError', error);
        const errorCode = error.code;
        const errorMsg = error.msg;
      });

    return <div />;
  };

  const handleValidateSelfie = async () => {
    try {
      setLoadingFull(true);

      const formData = new FormData();

      const selfieBuffer = Buffer.from(selfie, 'base64');
      const selfieFile = new File([selfieBuffer.buffer], 'selfie.png', {
        type: 'image/png',
      });

      formData.set('tokenSolicitud', token);
      formData.set('selfie', selfieFile);

      const response = await Axios.post(
        `${config.api.url}/distribuidoras/validar-distribuidora`,
        formData,
        {
          'Content-Type': 'multipart/form-data',
        },
      );

      const isError = get(response, 'data.output.payload.error', false);
      const isSuccess = get(response, 'data.success', false);
      if (isError || !isSuccess) {
        setErrorText(
          get(
            response,
            'data.output.payload.message',
            'No se pudo validar la identidad del cliente.',
          ),
        );
        setErrorSelfie(
          get(
            response,
            'data.output.payload.message',
            'No se puedo validar la identidad del cliente.',
          ),
        );
        setShowIndentityValidator(true);
        setErrorFaceCapture(true);
      } else {
        setErrorText('');
        setErrorSelfie(null);
        setErrorFaceCapture(false);
        setSuccessText('Identidad validada con éxito!');
        setSuccessSelfie('Identidad validada con éxito!');
      }
    } catch (error) {
      const errorRequest = JSON.parse(error.request.response);
      console.log(errorRequest.error.message);
      setErrorText(`${errorRequest.error.message}`);
      setErrorSelfie(`${errorRequest.error.message}`);
      setValidationAttempt(validationAttempt + 1);
    } finally {
      setLoadingFull(false);
    }
  };

  useEffect(() => {
    if (selfie) {
      handleValidateSelfie();
    }
  }, [selfie]);

  const handleTermsAgreedOpen = () => {
    setTermsAgreedOpen(true);
  };

  const handleTermsAgreedClose = () => {
    setTermsAgreedOpen(false);
  };

  const handleNext = () => setActiveStep(prev => prev + 1);

  const handleBack = () => {
    setActiveStep(prev => prev - 1);
    setTermsAgreed(false);
    setErrorSelfie(null);
    setErrorText('');
  };

  const handleConfirmarSolicitud = async () => {
    // TODO: call backend endpoint for confirmar solicitud de cambio
    // TODO: Ocupo ser FormData, para que se envie la selfie de nuevo

    const formData = new FormData();

    const selfieBuffer = Buffer.from(selfie, 'base64');
    const selfieFile = new File([selfieBuffer.buffer], 'selfie.png', {
      type: 'image/png',
    });

    if (tipoCambio === TIPO_CAMBIO.CELULAR) {
      formData.set('numeroCelular', numero);
    } else if (tipoCambio === TIPO_CAMBIO.TARJETA) {
      formData.set('numeroTarjeta', numero);
      formData.set('bancoId', bancoId);
    } else if (tipoCambio === TIPO_CAMBIO.SEGURO) {
      formData.set('seguroId', seguroId);
    }

    formData.set('tokenSolicitud', token);
    formData.set('selfie', selfieFile);

    setLoadingFull(true);
    try {
      const response = await Axios.post(
        `${config.api.url}/distribuidoras/confirmar-solicitud`,
        formData,
        {
          'Content-Type': 'multipart/form-data',
        },
      );
    } catch (error) {
      console.log(error);
      const errorMsg = error.response.data.error.message;
      setErrorText(errorMsg || 'error');
      return;
    } finally {
      setLoadingFull(false);
    }

    setSolicitudConfirmed(true);
  };

  const handleOnStart = () => {
    setStarted(true);
  };

  const STEPS = [
    {
      key: 'numero',
      render: () => (
        <NumberInputStep
          tipoCambio={tipoCambio}
          numero={numero}
          onNumeroChange={setNumero}
          touched={numeroTouched}
          onTouchedChange={setNumeroTouched}
          bancos={bancos}
          bank={bancoId}
          setBank={setBancoId}
          segurosDistribuidora={segurosDistribuidoras}
          seguro={seguroId}
          setSeguro={setSeguroId}
        />
      ),
      isNextDisabled: () =>
        (tipoCambio === 'tarjeta' &&
          (Boolean(validateNumero(tipoCambio, numero)) || !bancoId)) ||
        (tipoCambio === 'celular' &&
          Boolean(validateNumero(tipoCambio, numero))) ||
        (tipoCambio === 'seguro' && !seguroId),
    },
    {
      key: 'selfie',
      render: () => (
        <SelfieStep
          showIdentityValidator={showIdentityValidator}
          currentlyFaceCapture={currentlyFaceCapture}
          selfie={selfie}
          errorFaceCapture={errorFaceCapture}
          errorSelfie={errorSelfie}
          successSelfie={successSelfie}
          faceComponent={<FaceComponent />}
          onSetCurrentlyFaceCapture={setCurrentlyFaceCapture}
          identityValidationAttempts={identityValidationAttempts}
          validationAttempt={validationAttempt}
          onTermsAgreedChange={setTermsAgreed}
          onTermsAgreedOpen={handleTermsAgreedOpen}
        />
      ),
      isNextDisabled: () => !selfie || Boolean(errorSelfie) || disabled,
    },
  ];

  const totalSteps = STEPS.length - 1;

  const showError = !loading && !alreadyUsed && !notFound;

  return (
    <ContainerGeneral>
      <NavBarContainer>
        <Link to="/">
          <img className="logo" src="/images/logo.png" alt="ConmigoVales" />
        </Link>
      </NavBarContainer>

      {loading && <Loader />}

      {!notFound && Boolean(alreadyUsed) && (
        <Content>
          <h1>¡Gracias por tu preferencia!</h1>
          <div style={{ textAlign: 'center' }}>{alreadyUsed}</div>
        </Content>
      )}

      {notFound && (
        <Content>
          <div>Esta solicitud de cambio no existe o el link es incorrecto.</div>
        </Content>
      )}

      {!started && !alreadyUsed && !notFound && (
        <Content>
          <SummaryStep
            token={token}
            distribuidora={distribuidora}
            nombreCompletoDistribuidora={nombreCompletoDistribuidora}
            onStart={handleOnStart}
            setLoadingFull={setLoadingFull}
            tipoCambio={tipoCambio}
          />
        </Content>
      )}

      {showError && !solicitudConfirmed && started && (
        <>
          <Content>
            {STEPS[activeStep].render()}

            <Snackbar
              open={Boolean(successText)}
              autoHideDuration={6000}
              onClose={() => setSuccessText('')}
            >
              <Alert onClose={() => setSuccessText('')} severity="success">
                {successText}
              </Alert>
            </Snackbar>

            <Snackbar
              open={Boolean(errorText)}
              autoHideDuration={6000}
              onClose={() => setErrorText('')}
            >
              <Alert onClose={() => setErrorText('')} severity="error">
                {errorText}
              </Alert>
            </Snackbar>
          </Content>
        </>
      )}

      {started && !solicitudConfirmed && (
        <MobileStepper
          variant="dots"
          steps={STEPS.length}
          activeStep={activeStep}
          nextButton={
            activeStep === totalSteps ? (
              <Button
                size="medium"
                variant="contained"
                color="primary"
                onClick={handleConfirmarSolicitud}
                disabled={STEPS[activeStep].isNextDisabled()}
                style={{ textTransform: 'none' }}
              >
                Confirmar
              </Button>
            ) : (
              <Button
                size="small"
                onClick={handleNext}
                color="primary"
                disabled={STEPS[activeStep].isNextDisabled()}
                style={{ textTransform: 'none' }}
              >
                Siguiente
              </Button>
            )
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              color="primary"
              disabled={activeStep === 0}
              style={{ textTransform: 'none' }}
            >
              Atrás
            </Button>
          }
        />
      )}

      {showError && solicitudConfirmed && (
        <Content>
          <h1>¡Gracias por tu preferencia!</h1>
          <div className="greeting">{`Listo, ${nombreCompletoDistribuidora}!`}</div>
          {tipoCambio === 'seguro' && (
            <div className="greeting">
              Ahora, para finalizar tu proceso, necesitas firmar el documento
              que recibirás por WhatsApp en el chat con nombre “Weetrust” que
              corresponde a tu consentimiento de seguro; para actualizar tus
              beneficiarios o coasegurados por favor acude a tu sucursal o
              contacta a tu coordinador
            </div>
          )}
        </Content>
      )}

      {loadingFull && <Loader />}
      <Dialog
        open={termsAgreedOpen}
        onClose={handleTermsAgreedClose}
        maxWidth="sm"
      >
        <IconButton
          style={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}
          onClick={handleTermsAgreedClose}
        >
          <CloseIcon />
        </IconButton>
        <ContainerDialogTerms>
          <div>{parse(termsAndConditions, options)}</div>
        </ContainerDialogTerms>
      </Dialog>
    </ContainerGeneral>
  );
};

export default ConfirmarSolicitudCambio;
